import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { MfaPage } from '@/features/mfa/mfa-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Double facteur imposable du locataire (F8.8) — `GET /mfa-policy`, `PUT /mfa-policy` (`/tenant/admin`). */
export const Route = createFileRoute('/$tenant/mfa')({ component: MfaRoute });

function MfaRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="mfa" crumbs={[{ label: t('mfa.title') }]}>
      <MfaPage tenantId={tenant} />
    </ConsoleShell>
  );
}
